// CRM Records Tour
// Import and export, associations and keeping records clean
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_contacts); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const crmRecordsTour = {
  id: 'crm-records',
  name: 'CRM Records Tour',
  displayName: 'Master Your Records',
  description: 'Import and export, associations and keeping records clean',
  estimatedDuration: '4 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_contacts',
      popover: {
        title: "🗃️ Welcome to Your Records",
        description: `
          Your CRM is only as good as the data in it. Here is how records get in, how they connect, and how to keep them trustworthy.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📥 Import the Right Way",
        description: `
          Create your **custom fields first**, then import — importing before the fields exist is the number one cause of a messy database. Clean the spreadsheet: one header row, consistent dates and phone formats.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🗺️ Mapping Is the Careful Step",
        description: `
          The wizard maps each column to a field. Go slowly: a mismapped column silently puts wrong data across thousands of records. Decide up front whether duplicates skip, update, or create.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🧪 Test With Ten Rows",
        description: `
          Import a small sample first and inspect a couple of records. Two extra minutes here saves a full rollback later. **Tag the batch** so you have an undo path.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔗 Associations",
        description: `
          Link records to each other — contacts to a **company**, a referrer to who they referred. Associations give you the full account context instead of one isolated person.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📤 Exporting",
        description: `
          Export from a **filtered smart list** so you get exactly the segment you want. Handle the file carefully — it contains personal data.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🧹 Stay Clean",
        description: `
          Merge duplicates when you find them, keep naming consistent, and use fields for values you read back and tags for group membership. Mixing those two is why databases get messy.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Your Data Is Trustworthy",
        description: `
          You can now:

✅ Import safely with fields and mapping planned
✅ Test small and tag every batch
✅ Connect records with associations
✅ Export clean segments

**Next:** run a ten-row test import before your next real one.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
